import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { IntlProvider, useIntl } from 'react-intl-next';
import { Text } from '@atlaskit/primitives/compiled';
import commonCoreLazyI18nMessages from '../i18n/lazy';
import { getCodesFromLocale, useLazyI18nMessages } from './utils';
export var DEFAULT_LOCALE = 'en-US';
export var ProFormaIntlProvider = function ProFormaIntlProvider(_ref) {
  var _ref2, _ref3;
  var children = _ref.children,
    i18nMessages = _ref.i18nMessages,
    locale = _ref.locale;
  // `commonCoreI18nMessages` is a temporary variable required only while we need to maintain
  // access to the 'proforma-common-core' translations for other packages. Once the translations
  // are properly per package, this can be removed.
  var commonCoreI18nMessages = useLazyI18nMessages(locale, commonCoreLazyI18nMessages);
  if (!commonCoreI18nMessages) {
    return null;
  }
  var _getCodesFromLocale = getCodesFromLocale(locale),
    language = _getCodesFromLocale.language,
    country = _getCodesFromLocale.country;
  var messages = (_ref2 = (_ref3 = country && i18nMessages["".concat(language, "_").concat(country)]) !== null && _ref3 !== void 0 ? _ref3 : i18nMessages[language]) !== null && _ref2 !== void 0 ? _ref2 : i18nMessages.en;
  // `aggregateMessages` is a temporary variable required only while we need to maintain
  // access to the 'proforma-common-core' translations for other packages. Once the translations
  // are properly per package, this can be removed.
  var aggregateMessages = _objectSpread(_objectSpread({}, commonCoreI18nMessages), messages);
  return /*#__PURE__*/React.createElement(IntlProvider, {
    messages: aggregateMessages,
    locale: country ? "".concat(language, "-").concat(country) : language,
    defaultLocale: DEFAULT_LOCALE,
    defaultRichTextElements: {
      b: function b(chunks) {
        return /*#__PURE__*/React.createElement(Text, {
          weight: "bold"
        }, chunks);
      },
      strong: function strong(chunks) {
        return /*#__PURE__*/React.createElement(Text, {
          as: "strong"
        }, chunks);
      }
    }
  }, children);
};
export var withProFormaIntlProvider = function withProFormaIntlProvider(i18nMessages, WrappedComponent) {
  return function (props) {
    var intl = useIntl();
    return /*#__PURE__*/React.createElement(ProFormaIntlProvider, {
      i18nMessages: i18nMessages,
      locale: intl.locale
    }, /*#__PURE__*/React.createElement(WrappedComponent, props));
  };
};